import { Tooltip, TooltipTypes } from '@/components/tooltip/Tooltip';
import { TaskType } from '@/services/tasks/task.types';
import { useActiveSkills } from '@/services/tasks/useSkills';
import { useGetTaskIcon } from '@/services/tasks/useTasks';
import { FunctionComponent } from 'react';

interface TeanMemberTaskChitProps {
  task: TaskType;
}

const modalTooltipClassName =
  'z-[10000010] w-[350px] rounded-sm border border-slate-200 bg-white p-2 text-sm text-slate-900 shadow-lg';

const TeanMemberTaskChit: FunctionComponent<TeanMemberTaskChitProps> = ({ task }) => {
  const getTaskIcon = useGetTaskIcon();

  const skills = useActiveSkills();

  const Icon = getTaskIcon(task.id);

  const requiredSkills = skills.filter(s => task.skills.includes(s.id));

  return (
    <div
      className="p-2 border rounded-md flex flex-row space-x-3 items-center"
      style={{ backgroundColor: task.color, color: task.textColor }}
    >
      {Icon && <Icon className="w-5 h-5 shrink-0" />}
      <p className="text-sm font-semibold">{task.name}</p>
      <Tooltip type={TooltipTypes.info} className={modalTooltipClassName}>
        <div className="space-y-2">
          <p className="font-semibold text-md">Required Skills:</p>
          {requiredSkills.map(s => (
            <p className="text-sm">{s.name}</p>
          ))}
        </div>
      </Tooltip>
    </div>
  );
};

export default TeanMemberTaskChit;
